import styles from "./Settings.module.scss";
import layoutStyles from "./Layout.module.scss";
import { useTranslation } from "react-i18next";
import {NavLink} from "react-router-dom";
import React from "react";

const VersionInformation = () => {
    const { t } = useTranslation();

    return (
        <div className={styles._container}>
            <div className={`${styles.wrapper} ${styles.textContent}`}>
                <h1>{t("versionInformation.title")}</h1>
                <p dangerouslySetInnerHTML={{ __html: t("versionInformation.text") }}></p>
            </div>
        </div>
    );
};

export default VersionInformation;
